export enum PixKeyOptionEnum {
  document = 1,
  email = 2,
  phone = 3,
  random = 4,
}
